import { render, staticRenderFns } from "./mainPlayer.vue?vue&type=template&id=17268728&scoped=true"
import script from "./mainPlayer.vue?vue&type=script&lang=js"
export * from "./mainPlayer.vue?vue&type=script&lang=js"
import style0 from "./mainPlayer.vue?vue&type=style&index=0&id=17268728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17268728",
  null
  
)

export default component.exports